/** Ajuda — ChatBot (Cleo): conexão, o que ela faz, limites e boas práticas. */
export const chatbot = {
  id: "chatbot",
  titulo: "Cleo — atendente de IA no WhatsApp",
  icone: "MessageCircle",
  plano: "completo",
  intro: "A Cleo atende seus clientes no WhatsApp da loja: responde o cardápio, preços, horários e encaminha o pedido — 24 horas.",
  topicos: [
    {
      pergunta: "Como conecto o WhatsApp da loja?",
      resposta: "Na aba ChatBot, use Conectar e escaneie o QR Code com o WhatsApp do NÚMERO DA LOJA (Aparelhos conectados → Conectar aparelho). A conexão fica ativa mesmo com o celular longe do computador; se o aparelho desconectar, a tela avisa e basta escanear de novo.",
    },
    {
      pergunta: "O que a Cleo responde sozinha?",
      resposta: "Cardápio e preços (ela consulta os produtos reais da loja), horários de funcionamento, taxa e área de entrega, promoções ativas, status do pedido do cliente e dúvidas comuns. Pra fechar pedido, ela envia o link do cardápio — o cliente monta o carrinho lá e o pedido cai em Vendas → Pedidos.",
    },
    {
      pergunta: "A Cleo cobra ou recebe pagamento pelo WhatsApp?",
      resposta: "NÃO — por segurança, a Cleo nunca envia chave PIX nem dados de pagamento na conversa. Qualquer pedido de pagamento é transferido para atendimento humano. Isso evita golpes de troca de chave e mantém o pagamento nos canais oficiais (cardápio online ou na entrega).",
    },
    {
      pergunta: "Como assumo uma conversa no lugar da Cleo?",
      resposta: "Na tela do ChatBot, abra a conversa e assuma o atendimento — a Cleo pausa naquele cliente na hora e você digita como se fosse o WhatsApp normal. Clientes que pedem um atendente entram na fila de espera humana, que aparece destacada. Ao terminar, devolva a conversa pra Cleo.",
    },
    {
      pergunta: "Dá pra pausar a Cleo pra um cliente específico? E pra loja toda?",
      resposta: "Sim. Cada conversa tem pausa individual (a Cleo ignora aquele número pelo tempo escolhido). E o interruptor de IA no topo do painel desliga a Cleo pra loja inteira — útil em horário de pico, quando a equipe prefere atender à mão.",
    },
    {
      pergunta: "Como ajusto o jeito de falar da Cleo?",
      resposta: "Em ChatBot → Contexto você define a persona: tom de voz, nome do atendente, informações extras da loja (estacionamento, pet friendly, tempo médio) e instruções específicas. A Cleo também usa a memória do cliente — reconhece quem já pediu e sugere o de sempre.",
    },
    {
      pergunta: "A Cleo respeita os Turnos do Cardápio e a loja fechada?",
      resposta: "Sim. Com a loja fechada ela avisa o horário de reabertura em vez de aceitar pedido. Com turno ativo, ela só oferece o que está no cardápio daquele horário — se o cliente pedir um item de outro turno, ela explica quando ele volta e sugere alternativa.",
    },
    {
      pergunta: "O bot conectou mas o cliente não recebe as respostas. O que fazer?",
      resposta: "Primeiro confira em ChatBot se o aparelho consta conectado. Se estiver e mesmo assim as mensagens não chegarem, desconecte e escaneie o QR de novo. Persistindo, fale com o suporte — há diagnóstico do lado do servidor pra esse caso.",
    },
  ],
};
